import { FORMS_KEYS } from "helper/constant";
import React from "react";

const FormElement = ({ question, answer }) => {
  return (
    <div className="p-2 ">
      <div className="fs-16 demi-bold-text">{question}</div>
      <div>
        <i className="fas fa-arrow-right pr-1"></i>
        {answer ? (
          <>
            Yes <span className="form-label">&nbsp;&nbsp;+1</span>
          </>
        ) : (
          <span>No</span>
        )}
      </div>
    </div>
  );
};

const CAGEAIDForm = props => {
  return (
    <div>
      <div className="fs-18 bold-text pb-2">CAGE-AID</div>
      <FormElement
        question={FORMS_KEYS[18]["cut_down_substance_use"]}
        answer={props?.data?.cut_down_substance_use}
      />
      <FormElement
        question={FORMS_KEYS[18]["annoyed_by_criticism"]}
        answer={props?.data?.annoyed_by_criticism}
      />
      <FormElement
        question={FORMS_KEYS[18]["guilty_about_use"]}
        answer={props?.data?.guilty_about_use}
      />
      <FormElement
        question={FORMS_KEYS[18]["used_in_morning"]}
        answer={props?.data?.used_in_morning}
      />
      <br />
      <p className="fs-16 demi-bold-text display-info-class">
        CAGE-AID Score :{" "}
        <span className="fs-16 demi-bold-text form-label">
          {Boolean(props?.data?.cut_down_substance_use) +
            Boolean(props?.data?.annoyed_by_criticism) +
            Boolean(props?.data?.guilty_about_use) +
            Boolean(props?.data?.used_in_morning)}
        </span>
      </p>
    </div>
  );
};

export default CAGEAIDForm;
